import { useEffect, useState } from 'react';

/**
 * Hook: fetch the current user's Founding Member status.
 * Returns: { is_founding_member, founding_member_at, founding_member_number,
 *            total_platform_users, spots_remaining, auto_granted, loading }
 *
 * Policy (Feb 2026): All first-1,000 users are auto-granted permanent
 * founding status with full premium access at signup.
 */
export function useFoundingStatus() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = localStorage.getItem('connectmail_token');
        if (!token) {
          setLoading(false);
          return;
        }
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/platform/founding-status`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok && !cancelled) {
          const data = await res.json();
          setStatus(data);
        }
      } catch (e) {
        // Silently fail; status stays null and UI hides badge
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { ...(status || {}), loading };
}

export default useFoundingStatus;
